import { DefaultState, Filters } from 'store/types';
import { LodgingStatuses } from 'consts';

export const GET_LODGINGS_DATA_REQUEST = 'GET_LODGINGS_DATA_REQUEST';
export const GET_LODGINGS_DATA_SUCCESS = 'GET_LODGINGS_DATA_SUCCESS';
export const GET_LODGINGS_DATA_FAILURE = 'GET_LODGINGS_DATA_FAILURE';

export interface GetLodgingsParams {
  filters: Filters,
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
};

export interface GetLodgingsRow {
  address: string;
  deleteEnabled: boolean;
  id: string;
  lodgingType: string;
  status: LodgingStatuses;
  name: string;
  notesCount: number;
  likesCount: number;
  countActive: number;
  countCancelled: number;
  countInactive: number;
};

export interface GetLodgingsData {
  rows: GetLodgingsRow[];
  totalCount: number;
};

export type GetLodgingsState = DefaultState & {
  contents?: GetLodgingsData;
};

interface GetLodgingsDataRequest {
  type: typeof GET_LODGINGS_DATA_REQUEST;
};

interface GetLodgingsDataSuccess {
  type: typeof GET_LODGINGS_DATA_SUCCESS,
  contents: GetLodgingsData;
}

interface GetLodgingsDataFailure {
  type: typeof GET_LODGINGS_DATA_FAILURE;
}

export type GetLodgingsActionTypes = GetLodgingsDataRequest | GetLodgingsDataSuccess | GetLodgingsDataFailure;